export const INITIAL_CARD_FORM = {
  cardNumber: '',
  expiry: '',
  cvv: '',
};

export const getCardDigits = (value) => String(value || '').replace(/\D/g, '').slice(0, 16);

export const formatCardNumber = (value) => {
  const digits = getCardDigits(value);

  return digits.replace(/(.{4})/g, '$1 ').trim();
};

export const formatExpiry = (value) => {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 4);

  if (digits.length <= 2) {
    return digits;
  }

  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
};

export const getCardBrand = (cardNumber) => {
  const digits = getCardDigits(cardNumber);

  return digits.startsWith('5') ? 'MC' : 'VISA';
};

export const isValidCardDetails = (formData) => {
  const digits = getCardDigits(formData.cardNumber);
  const cvv = String(formData.cvv || '').replace(/\D/g, '');
  const expiry = String(formData.expiry || '');

  return digits.length === 16 && /^\d{2}\/\d{2}$/.test(expiry) && cvv.length >= 3;
};

export const getCardOrderMeta = (formData) => {
  const digits = getCardDigits(formData.cardNumber);

  return {
    brand: getCardBrand(formData.cardNumber),
    last4: digits.slice(-4),
  };
};
